module.exports = function() {
	return new Worker(__webpack_public_path__ + "b8736d008dca818ebe16.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./scripts/workers/yaml.worker.js
 ** module id = 387
 ** module chunks = 0
 **/